{
  "CREATE_SEARCH_MODAL_TITLE": {
    "text": "Save search",
    "crowdinContext": "Create saved search modal header title"
  },
  "CREATE_MODAL_NAME_INPUT_LABEL": {
    "text": "Name",
    "crowdinContext": "Label of the name edit input for create modal"
  },
  "CREATE_MODAL_CONFIRM_BUTTON_TEXT": {
    "text": "Save the search",
    "crowdinContext": "Text of a button to confirm creation of a saved search"
  },
  "TOAST_SEARCH_CREATE_SUCCESS": {
    "text": "The search has been saved!",
    "crowdinContext": "Toast message if saved search was successfully created"
  },
  "TOAST_SEARCH_CREATE_ERROR": {
    "text": "An error occurred while saving search. Try again later.",
    "crowdinContext": "Toast message if an error occurred while creating saved search"
  },
  "SETTINGS_CHANNEL_NAME_WEB": {
    "text": "FINN.no",
    "crowdinContext": "Name of the channel for web notifications"
  },
  "SETTING_CHANNEL_DESCRIPTION_WEB": {
    "text": "New matches are notified immediately under «Notifications» on the website and in the app",
    "crowdinContext": "Description of the setting for Web notifications"
  },
  "SETTINGS_CHANNEL_NAME_PUSH": {
    "text": "Push",
    "crowdinContext": "Name of the channel for push notifications"
  },
  "SETTING_CHANNEL_DESCRIPTION_PUSH": {
    "text": "New matches are notified immediately on mobile",
    "crowdinContext": "Description of the setting for Push notifications"
  },
  "SETTINGS_CHANNEL_NAME_EMAIL": {
    "text": "E-mail",
    "crowdinContext": "Name of the channel for email notifications"
  },
  "SETTING_CHANNEL_DESCRIPTION_EMAIL": {
    "text": "New matches are sent daily by e-mail",
    "crowdinContext": "Description of the setting for Email notifications"
  },
  "SETTING_CHANNEL_TOGGLE_ARIA_LABEL": {
    "text": "Toggle switch",
    "crowdinContext": "Aria label for notification toggle switch"
  },
  "NAME_INPUT_MAX_LENGTH_HELP_TEXT": {
    "text": "Max 50 characters",
    "crowdinContext": "Name input help text informing about max length"
  },
  "NAME_INPUT_EMPTY_HELP_TEXT": {
    "text": "You must give the search a name",
    "crowdinContext": "Name input help text informing about not leaving the name empty"
  },
  "DELETE_SEARCH_MODAL_TITLE": {
    "text": "Are you sure you want to delete",
    "crowdinContext": "Delete saved search modal header title"
  },
  "DELETE_SEARCH_MODAL_DESCRIPTION": {
    "text": "Both notifications and saved searches will be deleted forever.",
    "crowdinContext": "Description informing user about deleting both saved search and its notification settings"
  },
  "DELETE_MODAL_CONFIRM_BUTTON_TEXT": {
    "text": "Delete the search",
    "crowdinContext": "Text of a button to confirm deletion of a saved search"
  },
  "TOAST_SEARCH_DELETE_ERROR": {
    "text": "The search was not deleted, try again in a little while!",
    "crowdinContext": "Toast message if an error occurred while deleting saved search"
  },
  "TOAST_SEARCH_DELETE_SUCCESS": {
    "text": "The search has been deleted",
    "crowdinContext": "Toast message if settings was successfully deleted"
  },
  "TOAST_SEARCH_UPDATE_SUCCESS": {
    "text": "The changes have been saved",
    "crowdinContext": "Toast message if settings was successfully updated"
  },
  "CANCEL_BUTTON_TEXT": {
    "text": "Cancel",
    "crowdinContext": "Cancel button text"
  },
  "RENAME_MODAL_NAME_INPUT_LABEL": {
    "text": "Name of the search",
    "crowdinContext": "Label of the name edit input for rename modal"
  },
  "RENAME_MODAL_CONFIRM_BUTTON_TEXT": {
    "text": "Change the name",
    "crowdinContext": "Text of a button to confirm rename of a saved search"
  },
  "TOAST_SEARCH_RENAME_ERROR": {
    "text": "The name change was not saved, try again in a little while!",
    "crowdinContext": "Toast message if an error occurred while renaming saved search"
  },
  "TOAST_SEARCH_NOTIFICATION_EDIT_ERROR": {
    "text": "The change was not stored",
    "crowdinContext": "Toast message if an error occurred while editing saved search notification"
  },
  "EDIT_MODAL_RENAME_BUTTON_TEXT": {
    "text": "Change the name of the search",
    "crowdinContext": "Edit modal rename button text"
  },
  "EDIT_MODAL_FOOTER_DELETE_BUTTON_TEXT": {
    "text": "Delete the search",
    "crowdinContext": "Button text opening the saved search deletion modal"
  },
  "LOADING_MODAL_TEXT": {
    "text": "Give us a few seconds and we'll get your settings",
    "crowdinContext": "Text displayed when loading re-fetched saved search"
  },
  "ERROR_MODAL_TITLE": {
    "text": "Oopsie",
    "crowdinContext": "Error modal title displayed when saved search fails to load"
  },
  "ERROR_MODAL_INFO_RETRY_TEXT": {
    "text": "We were unable to retrieve your settings, let's try again.",
    "crowdinContext": "Error modal information about failing to load a saved search and possibility to try again"
  },
  "ERROR_MODAL_RETRY_BUTTON_TEXT": {
    "text": "Try again",
    "crowdinContext": "Error modal retry button text"
  },
  "ERROR_MODAL_IMAGE_ALT_TEXT": {
    "text": "Error loading search",
    "crowdinContext": "Alt text for image displayed when loading the search fails"
  }
}
